import { listIdeas } from '../../../../../sdk/src/graphql/queries';
import { useCallback, useEffect, useMemo, useState } from 'react';
import useSwr from 'swr';
import { useHistory } from 'react-router-dom';

import PollCardList from '@components/elements/PollCardList';

import {
  DEFAULT_IDEA_DETAIL_FIELDS,
  formatIdeaData,
  formatPollData,
  FormattedPoll,
} from '@utils/Poll';

import { listPollsByOwner } from '@sdk/managers/PollsManager';

import { useAuth } from '@hooks/Auth';
import { toast } from 'react-hot-toast';
import { PollStatus } from '@sdk/models';
import { listIdea } from '@sdk/managers/IdeaManager';
import { isPast } from 'date-fns';

interface getIdeasByOwnerResponse {
  items: FormattedPoll[];
  nextToken: number;
}

const MyIdea: React.FC = () => {
  const history = useHistory<any>();
  const { user } = useAuth();
  // const { data, error } = useSwr<any>(
  //   user?.username ? ['/poll/owner', user?.username] : null,
  //   getIdeasByOwner
  // );
  const [data, setData] = useState<any>();
  const getIdeasByOwner = async (owner: string): Promise<any> => {
    if (!owner) throw new Error('You are not logged in.');
    console.log('clgt');
    try {
      const res: any = await listIdea(
        [
          {
            items: DEFAULT_IDEA_DETAIL_FIELDS,
          },
          'nextToken',
        ],
        {
          filter: {
            owner: {
              eq: owner,
            },
          },
        }
      );
      // console.log(res);
      // const {
      //   data: {
      //     result: { items, nextToken },
      //   },
      // } = res;
      const resData: any = [];
      for (let i = 0; i < res.data.result.items.length; i++) {
        const temp = await formatIdeaData(res.data.result.items[i]);
        resData.push(temp);
      }
      setData(resData);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getIdeasByOwner(user?.username);
  }, []);

  const onPollSelect = useCallback(
    (poll: FormattedPoll) => {
      history.push(`/idea/${poll.id}`);
    },
    [history]
  );

  const onFinishedPollSelect = useCallback(
    (poll: FormattedPoll) => {
      history.push(`/idea/${poll.id}`);
    },
    [history]
  );

  const [finishedPolls, recentPolls] = useMemo(() => {
    console.log(data);
    if (!data) return [undefined, undefined];
    const finished: FormattedPoll[] = [];
    const recent: FormattedPoll[] = [];

    data.forEach((poll) => {
      if (isPast(poll.endDate)) finished.push(poll);
      else recent.push(poll);
    });

    return [finished, recent];
  }, [data]);

  return (
    <div>
      <h1 className="mt-8 mb-2 text-2xl font-bold text-white">Your Ideas</h1>

      {(finishedPolls?.length || 0) > 0 && (
        <>
          <h2 className="mt-8 mb-2 text-lg font-bold text-green">Finished</h2>
          <PollCardList
            data={finishedPolls}
            loading={!data}
            isIdea={true}
            duplicate={(poll) => {
              history.push(`/idea/${poll.id}/create`);
            }}
            onSelect={onFinishedPollSelect}
            accessory="View Poll"
          />
        </>
      )}

      {(recentPolls?.length || 0) > 0 && (
        <>
          <h2 className="mt-8 mb-2 text-lg font-bold text-cyan">Ongoing</h2>
          <PollCardList
            data={recentPolls}
            loading={!data}
            isIdea={true}
            duplicate={(poll) => {
              console.log('éo zô');
              history.push(`/idea/${poll.id}/create`);
            }}
            onSelect={onPollSelect}
            type="border"
            accessory="View Poll"
          />
        </>
      )}
    </div>
  );
};

export default MyIdea;
